import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import ReactSelect from 'react-select';

import './Select.css';

const Select = ({
                    className, errorMessage, isDisabled, label, onChange, options, placeholder, value, zIndex,
                }) => {
    const { localizedBody } = useSelector((state) => state);

    return (
      <article className={className}>
        <p className="body-2 mt2-sm">{label}</p>
        <ReactSelect
          classNamePrefix="react-select"
          id={label}
          isDisabled={isDisabled}
          options={options}
          placeholder={placeholder || localizedBody.RL_Select}
          styles={{
              container: (styles) => ({ ...styles, zIndex }),
              control: (styles) => ({
                  ...styles,
                  borderColor: errorMessage !== '' ? 'red' : 'lightgrey',
                  padding: '0px 0px 0px 3px',
                  zIndex,
              }),
          }}
          value={value
                  ? {
                      label: options.find((option) => option.value === value).label || null,
                      value,
                  }
                  : null}
          onChange={({ value: newValue }) => onChange(newValue)}
        />
        {errorMessage && <p className="text-color-error body-4 mt1-sm">{errorMessage}</p>}
      </article>
    );
};

Select.defaultProps = {
    className: 'ncss-col-sm-12 ncss-col-md-6 ta-sm-l va-sm-t',
    errorMessage: '',
    isDisabled: false,
    placeholder: '',
    value: null,
    zIndex: 10,
};

Select.propTypes = {
    className: PropTypes.string,
    errorMessage: PropTypes.string,
    isDisabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    zIndex: PropTypes.number,
};

export default Select;
